/* eslint-disable new-cap */
/* eslint-disable no-plusplus */
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";

export const createSinglePagePdf = async (
  templateRef,
  filename = "template",
  options = {}
) => {
  return new Promise((resolve, reject) => {
    const content = templateRef?.current;
    if (!content) {
      reject(new Error("Template reference is not available."));
      return;
    }

    const { xMargin = 10, yMargin = 10, imgWidth = 208 } = options;

    const scale = 2;
    const minPageHeight = 297;
    const quality = 0.6;

    html2canvas(content, { scale })
      .then((canvas) => {
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        const finalImgWidth = imgWidth - xMargin * 2;

        const imgHeight = (canvasHeight * finalImgWidth) / canvasWidth;
        const pageHeight = Math.max(imgHeight + yMargin * 2, minPageHeight);

        const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);

        const pageCanvas = document.createElement("canvas");
        const ctx = pageCanvas.getContext("2d");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = canvasHeight;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.drawImage(canvas, 0, 0);

        const imgData = pageCanvas.toDataURL("image/jpeg", quality);

        pdf.addImage(
          imgData,
          "JPEG",
          xMargin,
          yMargin,
          finalImgWidth,
          imgHeight
        );

        pdf.save(`${filename}.pdf`);
        resolve();
      })
      .catch(reject);
  });
};
